module.exports = __webpack_public_path__ + "static/media/facebook.464594b1.svg";